document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.view-all-inline').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      for (let i = 0; i < 6; i++) {
        const star = document.createElement('span');
        star.className = 'star-particle';
        star.textContent = '★';
        const angle = (i / 6) * 360;
        const rad = angle * Math.PI / 180;
        const dist = 30 + Math.random() * 20;
        star.style.cssText = `
          left: ${x}px;
          top: ${y}px;
          font-size: ${8 + Math.random() * 8}px;
          --tx: ${Math.cos(rad) * dist}px;
          --ty: ${Math.sin(rad) * dist}px;
        `;
        btn.appendChild(star);
        setTimeout(function () { star.remove(); }, 700);
      }
    });
  });
});